import React, {ReactElement} from "react";
import {FormattedNumber} from "./FormattedNumber";

export class FormattedNumberDiff extends React.Component<any, any> {

    render(): ReactElement {
        let props: any = {...this.props};

        if (!props.value) {
            return (<small className="text-sm font-medium text-info">&nbsp;0%</small>);
        }

        if(props.revert) {
            if (0 < props.value) {
                return (<small
                    className="text-sm font-medium text-danger">&nbsp;↑ {FormattedNumber.format(props.value || '', 2, '.', ' ', '-')}%</small>);
            }
            return (<small
                    className="text-sm font-medium text-success">&nbsp;↓ {FormattedNumber.format(props.value || '', 2, '.', ' ', '-')}%</small>
            );
        }

        if (0 < props.value) {
            return (<small
                className="text-sm font-medium text-success">&nbsp;↑ {FormattedNumber.format(props.value || '', 2, '.', ' ', '-')}%</small>);
        }
        return (<small
                className="text-sm font-medium text-danger">&nbsp;↓ {FormattedNumber.format(props.value || '', 2, '.', ' ', '-')}%</small>
        );
    }
}
